export default "__VITE_ASSET__d57eb483__"